import { Button, Text } from '@react-spectrum/s2';
import ChevronRight from '@react-spectrum/s2/icons/ChevronRight';
import { useCallback, useState } from 'react';

import { TypewriterOnce } from '../components/TypewriterOnce';

type ReplyPromptScreenProps = {
	onConfirm: () => void;
	onDidntGetText: () => void;
};

export const ReplyPromptScreen = ({
	onConfirm,
	onDidntGetText,
}: ReplyPromptScreenProps) => {
	const [typingDone, setTypingDone] = useState(false);
	const handleTypingDone = useCallback(() => setTypingDone(true), []);

	return (
		<div className="flex h-full w-full items-center justify-center">
			<div className="w-full max-w-[760px] px-8">
				<div
					className="mb-8 overflow-hidden"
					style={{
						width: 56,
						height: 56,
						borderRadius: 14,
						background: 'white',
						padding: 6,
					}}
				>
					<img
						src="/chat-bubble-icon.svg"
						alt=""
						style={{ width: '100%', height: '100%', display: 'block' }}
					/>
				</div>

				<h2
					className="mb-10"
					style={{
						fontSize: 'clamp(26px, 4vw, 40px)',
						fontWeight: 700,
						letterSpacing: '-0.02em',
						lineHeight: 1.15,
						color: 'var(--text-primary)',
					}}
				>
					<TypewriterOnce
						text="Great, just sent it. Give it a try and respond back to me — just say “Can’t wait to get started.”"
						onDone={handleTypingDone}
					/>
				</h2>

				<div
					style={{
						opacity: typingDone ? 1 : 0,
						transition: 'opacity 400ms ease',
						pointerEvents: typingDone ? 'auto' : 'none',
					}}
				>
					<div className="mb-10 flex flex-col" style={{ gap: 14 }}>
						<div
							style={{
								alignSelf: 'flex-start',
								maxWidth: 420,
								background: 'white',
								borderRadius: 20,
								padding: '14px 18px',
								fontSize: 15,
								lineHeight: 1.45,
								color: 'var(--text-primary)',
								boxShadow: '0 1px 2px rgba(0,0,0,0.04)',
							}}
						>
							Hey — it&apos;s Bridgeway. Text me here anytime. I&apos;ll always
							respond.
						</div>
						<div
							style={{
								alignSelf: 'center',
								background: '#3F2EE0',
								borderRadius: 20,
								padding: '12px 20px',
								fontSize: 15,
								lineHeight: 1.45,
								color: 'white',
								fontWeight: 500,
							}}
						>
							Can&apos;t wait to get started.
						</div>
					</div>

					<Button
						variant="primary"
						staticColor="black"
						fillStyle="fill"
						size="L"
						onPress={onConfirm}
					>
						<Text>Sent it</Text>
						<ChevronRight />
					</Button>

					<div className="mt-4">
						<button
							type="button"
							onClick={onDidntGetText}
							style={{
								background: 'none',
								border: 'none',
								padding: 0,
								cursor: 'pointer',
								color: 'var(--text-muted)',
								fontSize: 14,
								textDecoration: 'underline',
							}}
						>
							Didn&apos;t get the text
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};
